import { render, staticRenderFns } from "./ConversationArea.vue?vue&type=template&id=4be614c8&scoped=true"
import script from "./ConversationArea.vue?vue&type=script&lang=js"
export * from "./ConversationArea.vue?vue&type=script&lang=js"
import style0 from "./ConversationArea.vue?vue&type=style&index=0&id=4be614c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be614c8",
  null
  
)

export default component.exports